import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import { isEmpty } from 'lodash';

export const useGetProvince = (searchparam) => {
    const checkParams = !isEmpty(searchparam) ? `?search=${searchparam}` : '';
    return useQuery({
        queryKey: ['data-province', searchparam],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/master-data/province${checkParams}`);
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!searchparam,
    });
};

export const useGetCity = (province_id, searchparam) => {
    const checkParams = !isEmpty(searchparam) ? `?search=${searchparam}` : '';
    return useQuery({
        queryKey: ['data-city', searchparam],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/master-data/city/${province_id}${checkParams}`);
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!searchparam,
    });
};

export const useGetDistrict = (city_id, searchparam) => {
    const checkParams = !isEmpty(searchparam) ? `?search=${searchparam}` : '';
    return useQuery({
        queryKey: ['data-district', searchparam],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/master-data/district/${city_id}${checkParams}`);
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!searchparam,
    });
};

export const useGetVillage = (district_id, searchparam) => {
    const checkParams = !isEmpty(searchparam) ? `?search=${searchparam}` : '';
    return useQuery({
        queryKey: ['data-village', searchparam],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/master-data/village/${district_id}${checkParams}`);
            return data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!searchparam,
    });
};
